import { BrandColor } from '@Shared.Angular/@types/brandColor';
import React, { useState } from 'react';

type Props = {
  name: string;
  color?: string;
  brandColor?: BrandColor;
  onRemoveChip?: (name: string) => void;
  canRemove?: boolean;
  canEdit?: boolean;
  limitWidth?: boolean;
  onUpdateChip?: (arg: { name: string; updatedName: string }) => void;
  clearValidationError?: () => void;
  title?: string;
  fontColor?: string;
  showSwatch?: boolean;
  swatchColor?: string;
  id?: string;
};

const Chip = ({
  name,
  color,
  brandColor,
  onRemoveChip,
  canRemove = false,
  canEdit = false,
  limitWidth = false,
  onUpdateChip,
  clearValidationError,
  title,
  fontColor = '#ffffff',
  showSwatch = false,
  swatchColor,
  id
}: Props) => {
  const [isEditing, setIsEditing] = useState(false);
  const [updatedName, setUpdatedName] = useState(name);

  const handleTagClick = () => {
    if (canEdit) {
      clearValidationError?.();
      setIsEditing(true);
    }
  };

  const handleSave = () => {
    setIsEditing(false);
    if (onUpdateChip && updatedName.trim() !== name) {
      onUpdateChip({ name: name, updatedName: updatedName.trim() });
    }
  };

  const handleCancel = () => {
    setUpdatedName(name);
    setIsEditing(false);
    clearValidationError?.();
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUpdatedName(event.target.value);
    clearValidationError?.();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSave();
    } else if (event.key === 'Escape') {
      handleCancel();
    }
  };

  const brandColorClass = brandColor
    ? ` custom-chip-container--${brandColor}`
    : '';

  return (
    <span
      id={id}
      className={`custom-chip-container${brandColorClass} ${
        limitWidth ? 'limit-width' : ''
      }`}
      title={title}
      style={{
        backgroundColor: color ? `#${color}` : undefined,
        color: fontColor,
        display: isEditing ? 'flex' : undefined
      }}
      onClick={handleTagClick}
    >
      {showSwatch && swatchColor && (
        <span
          className="chip-swatch"
          style={{ backgroundColor: swatchColor }}
        ></span>
      )}
      {isEditing ? (
        <span>
          <input
            type="text"
            value={updatedName}
            onBlur={handleSave}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            autoFocus
          />
        </span>
      ) : (
        <span className="chip-text" title={limitWidth ? name : undefined}>
          {name}
        </span>
      )}
      {canRemove && (
        <button
          type="button"
          onClick={() => onRemoveChip?.(name)}
          style={{ color: fontColor }}
        >
          &times;
        </button>
      )}
    </span>
  );
};

export default Chip;
